module.exports = ".bg-blue {\n  background-color: #193E63!important;\n}\n"